/**
 * Environment types.
 *
 * These can be used against `process.env.NODE_ENV` to determine the current
 * environment.
 *
 * @see {@link isDevModeEnabled}
 */
enum Env {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
}

/**
 * If `true`, force 'Dev Mode' to be `true` when running in production.
 */
let devMode = false;

/**
 * Check if 'Dev Mode' is currently enabled.
 *
 * @see {@link enableDevMode}
 */
export function isDevModeEnabled(): boolean {
    return process.env.NODE_ENV === Env.DEVELOPMENT || devMode;
}

/**
 * Force enabling of 'Dev Mode'
 *
 * This will give the 'Public API' access to development and debugging
 * functions, and generally make Signage think it's running in 'development'
 * rather than 'production'.
 */
export function enableDevMode(): void {
    devMode = true;
}
